export const userDefaultValue = { 
  id: 0, 
  username: '',
  password: '',
  first_name: '', 
  last_name: '',
  phone: '', 
  email: '', 
  about: '',
  buyer_type: '',
  status: 1
};

export const directionDefaultValue = { 
  id: 0, 
  client_id: '',
  name: '',
  country: 'PR', 
  city: '',
  address: '', 
  state: 'PR', 
  zip_code: '',
  latitude: '',
  longitude: '',
  is_default: false,
  status: 1,
};

export const EnumBuyerType = {
    USER: 1,
    COMPANY: 2,
    SUPER_MARKET: 3,
    DISTRIBUTOR: 4,
    COOPERATIVE: 5,
    OTHER: 6
  }
  
  export const BUYER_TYPE = [
    { name: "Usuario", value: EnumBuyerType.USER },
    { name: "Compañia", value: EnumBuyerType.COMPANY },
    { name: "Super mercados", value: EnumBuyerType.SUPER_MARKET },
    { name: "Distribudora", value: EnumBuyerType.DISTRIBUTOR },
    { name: "Cooperativa", value: EnumBuyerType.COOPERATIVE },
    { name: "Otro", value: EnumBuyerType.OTHER },
  ]
  
  export function BuyerTypeDescription(value) {
    const data_filter = BUYER_TYPE.filter(data => data.value === value);
    return !data_filter[0]?.name ? 'No definido' : data_filter[0].name;
  }